import { Button, Link } from "@chakra-ui/react";
import React from "react";
import { FaDiscord } from "react-icons/fa";
function DiscordButton(props) {
  const { text, url } = props;
  return (
      <Button
        as={Link}
        color="white"
        fontWeight="bold"
        borderRadius={8}
        display="inline-flex"
        alignItems="center"
        padding="10px 15px"
        backgroundColor="#7289da"
        _hover={{ backgroundColor: "#5b6eae", textDecoration: "none" }}
        leftIcon={<FaDiscord />}
        textDecoration={"none"}
        href={url}
      >
        {text}
      </Button>
  )
}

export default DiscordButton;
